import { Link } from "react-router-dom";
// import logo from "../assets/img/XC_Helpdesk.jpg";
import logo from "../assets/img/CodeData.jpg";
import logoSM from "../assets/img/XC_Helpdesk_sm.png";
import { getSessionData } from "../utils/storageUtils";
import { PERMISSOES_POR_PERFIL } from "../types/PermissaoInterface";

import { useContext } from 'react';
import Servidorftp from '../router/routes';

const LeftBar: React.FC = (): JSX.Element => {
  // Obtém o perfil do usuário do localStorage (agora será 'agente' ou 'usuario' baseado na função do token)
  const perfil = getSessionData("PerfilUsuario") || "usuario";
  const permissoes = PERMISSOES_POR_PERFIL[perfil.toLowerCase()] ?? {
    cadastro: false,
    paineldecontrole: false,
    tickets: false,
  };

  return (
    <div className="leftside-menu">
      <a href="/" className="logo text-center ">
        <span className="logo-lg">
          <img src={logo} alt="" style={{ height: "48px" }} />
          <span style={{ marginLeft: "10px", color: "black", fontWeight: "bold", fontSize: "14px", letterSpacing: "1px" }}>
            HELP DESK
          </span>
        </span>
        <span className="logo-sm">
          <img src={logo} alt="" style={{ height: "30px" }} />
        </span>
      </a>

      <div className="h-100" id="leftside-menu-container" data-simplebar>
        <ul className="side-nav">
          {/* Cadastro - Só exibe se tiver permissão */}
          {permissoes.cadastro && (
            <li className="side-nav-item">
              <a
                data-bs-toggle="collapse"
                href="#Cadastro"
                aria-expanded="false"
                aria-controls="Cadastro"
                className="side-nav-link"
              >
                <span
                  className="iconify"
                  data-icon="fluent:people-list-24-filled"
                  data-width="22"
                ></span>
                <span style={{ margin: "15px" }}> Cadastro </span>
                <span className="menu-arrow"></span>
              </a>
              <div className="collapse" id="Cadastro">
                <ul className="side-nav-second-level">
                  <li>
                    <Link to={"/cadastro/empresa"}>Empresa</Link>
                  </li>
                  <li>
                    <Link to={"/cadastro/usuario"}>Usuário</Link>
                  </li>
                  <li>
                    <Link to={"/cadastro/codigodosistema"}>Códigos do Sistema</Link>
                  </li>
                </ul>
              </div>
            </li>
          )}

          {/* Painel de Controle */}
          {permissoes.paineldecontrole && (
            <li className="side-nav-item">
              <Link to="/kpi/dashboard/paineldecontrole" className="side-nav-link">
                <span
                  className="iconify"
                  data-icon="carbon:dashboard"
                  data-width="22"
                ></span>
                <span style={{ margin: "15px" }}> Painel de Controle </span>
              </Link>
            </li>
          )}

          {/* Tickets */}
          {permissoes.tickets && (
            <li className="side-nav-item">
              <Link to="/tickets" className="side-nav-link">
                <span
                  className="iconify"
                  data-icon="carbon:ticket"
                  data-width="22"
                ></span>
                <span style={{ margin: "15px" }}> Tickets </span>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export { LeftBar };
